module.exports = __webpack_public_path__ + "static/img/sem-foto.254d321.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/survey/sem-foto.png
// module id = sIi8
// module chunks = 0